<template>
  <div>

    <br />

    
        
    <Toolbar class="p-mb-4">
      <template slot="left">
        <span class="p-input-icon-left">
        </span>
      </template>
      <template slot="right">
        <div 
          style="width: 185px; display: flex; justify-content: flex-end;" 
          v-if="$store.getters['auth/getMyProfile'] && $store.getters['auth/getMyProfile'].role && $store.getters['auth/getMyProfile'].role.showAdmin"
        >
          <ProgressSpinner
            v-if="requesting"
            style="width:100%; height:25px;" 
            strokeWidth="5" 
            fill="#EEEEEE" 
            animationDuration=".5s"
          />
          <Button
            v-else
            label="Add Widget"
            icon="pi pi-plus"
            @click="addWidget()"
          />
        </div>
      </template>
    </Toolbar>

    <WidgetsTable
      :widgets="userWidgets"
      :loading="userWidgetsLoading"
      @editWidget="editWidget"
    />

    <WidgetForm 
      :widgetFormDialog="addWidgetForm"
      :widgetToEdit="widgetToEdit"
      :disabledArr="disabledArr"
      :resetForm="resetWidgetForm"
      :refreshForm="refreshWidgetForm"
      :user="user1"
      @close="addWidgetForm = false"
      @updated="addWidgetForm = false, getUserWidgetsByHardByUserId()"
      @saved="addWidgetForm = false, getUserWidgetsByHardByUserId()"
    />
  
  </div>
</template>

<script>
import UserService from "@/service/UserService";

import WidgetsTable from '../../universalComponents/widget/WidgetsTable.vue'
import WidgetForm from '../../universalComponents/widget/WidgetForm.vue'

export default {
  components: {
    WidgetsTable,
    WidgetForm
  },
  created() {
    if (this.user && this.user.id) {
      this.user1 = {...this.user}
      this.getUserWidgetsByUserId()
    }
  },
  props: ["user"],
  data: () => ({
    userService: new UserService(),
    user1: {},
    requesting: false,
    addWidgetForm: false,
    resetWidgetForm: 0,
    refreshWidgetForm: 0,
    userWidgetsLoading: false,
    userWidgets: [],
    widgetToEdit: {},
    disabledArr: []
  }),
  computed: {
    profile() {
      return this.$store.getters['auth/getMyProfile']
    }
  },
  watch: {
    user(val) {
      if (val && val.id) {
        this.user1 = val
        this.getUserWidgetsByUserId()
      }
    }
  },
  methods: {
    editWidget(widget) {
      // 

      this.addWidgetForm = true
      this.resetWidgetForm++
      setTimeout(() => {
        this.widgetToEdit = widget
        this.disabledArr = ['widget']
        this.refreshWidgetForm++
      }, 10)
    },
    addWidget() {
      this.disabledArr = []
      this.widgetToEdit = {}
      this.addWidgetForm = true
      this.resetWidgetForm++
    },
    getUserWidgetsByUserId() {
      if (this.user1) {
        this.userWidgetsLoading = true
        

        if (this.profile && this.user1.id == this.profile.id) {
          this.userService
            .getUserWidgets(this.user1.id)
            .then(data => {
              

              this.userWidgetsLoading = false
              this.userWidgets = data
            })
            .catch(error => {
              this.userWidgetsLoading = false
              
              this.$store.dispatch('addErrorMessage', {
                severity: 'error',
                content: 'Some data was not loaded from "getUserWidgets/{userId}"'
              })
            })
        } else {
          this.userService
            .getUserWidgetsByUserId(this.user1.id)
            .then(data => {
              

              this.userWidgetsLoading = false
              this.userWidgets = data
            })
            .catch(error => {
              this.userWidgetsLoading = false
              
              this.$store.dispatch('addErrorMessage', {
                severity: 'error',
                content: 'Some data was not loaded from "getUserWidgets/{userId}"'
              })
            })
        }
      }
    },
    getUserWidgetsByHardByUserId() {
      this.userWidgetsLoading = true
      

      if (this.profile && this.user1.id == this.profile.id) {
        this.userService
          .getUserWidgetsByHard(this.user1.id)
          .then(data => {
            

            this.userWidgetsLoading = false
            this.userWidgets = data
          })
          .catch(error => {
            this.userWidgetsLoading = false
            
            this.$store.dispatch('addErrorMessage', {
              severity: 'error',
              content: 'Some data was not loaded from "getUserWidgets/{userId}"'
            })
          })
      } else {
        this.userService
          .getUserWidgetsByUserId(this.user1.id)
          .then(data => {
            

            this.userWidgetsLoading = false
            this.userWidgets = data
          })
          .catch(error => {
            this.userWidgetsLoading = false
            
            this.$store.dispatch('addErrorMessage', {
              severity: 'error',
              content: 'Some data was not loaded from "getUserWidgets/{userId}"'
            })
          })
      }
    }
  }
}
</script>

<style>

</style>